import {
  DateFormField,
  MultiselectFormField,
  SimpleSelectFormField,
  StateSelectFormField,
  TextFormField,
} from "@/components/ui";
import { CheckboxFormField } from "@/components/ui/FormFields/CheckboxFormField/CheckboxFormField";
import {
  CONTACT_INDIVIDUAL_EXPERT_WITNESS_SPECIALIZATIONS,
  CONTACT_INDIVIDUAL_SUBTYPES,
  CONTACT_INDIVIDUAL_SUBTYPES_WITH_ADDITIONAL_FIELDS,
  GENDERS,
  LANGUAGES,
  RACES,
  TITLES,
} from "@/lib/data/static/contactStatics";
import { useFormContext } from "react-hook-form";

export const ContactIndividualFormSection = () => {
  const form = useFormContext();
  const individualSubTypes: (typeof CONTACT_INDIVIDUAL_SUBTYPES)[number][] =
    form.watch("individualSubTypes") ?? [];
  return (
    <>
      <MultiselectFormField
        label="Contact sub-types"
        register={form.register("individualSubTypes")}
        options={CONTACT_INDIVIDUAL_SUBTYPES.map((subtype) => ({
          label: subtype,
          value: subtype,
        }))}
        maxCount={1}
        dataTestId="contact-individual-subtypes"
      />
      <TextFormField
        register={form.register("individualFirstName")}
        label="First name*"
        dataTestId="contact-individual-first-name"
      />
      <TextFormField
        register={form.register("individualMiddleName")}
        label="Middle name"
      />
      <TextFormField
        register={form.register("individualLastName")}
        label="Last name*"
        dataTestId="contact-individual-last-name"
      />
      <TextFormField
        register={form.register("individualNickname")}
        label="Nickname"
      />
      <SimpleSelectFormField
        register={form.register("title")}
        label="Title"
        items={TITLES}
      />
      {individualSubTypes.some((subType) =>
        CONTACT_INDIVIDUAL_SUBTYPES_WITH_ADDITIONAL_FIELDS.includes(
          subType as (typeof CONTACT_INDIVIDUAL_SUBTYPES_WITH_ADDITIONAL_FIELDS)[number],
        ),
      ) && (
        <>
          <DateFormField
            label="Date of birth"
            register={form.register("individualDateOfBirth")}
            name="individualDateOfBirth"
          />
          <TextFormField
            register={form.register("individualSocialSecurityNumber")}
            label="SSN"
          />
          <TextFormField
            register={form.register("individualDriverLicenseNumber")}
            label="Driver license number"
          />
          <StateSelectFormField
            register={form.register("individualDriverLicenseState")}
            label="Driver license state"
            name="individualDriverLicenseState"
            country="United States"
            labelType="short"
            valueType="short"
          />

          <SimpleSelectFormField
            label="Gender"
            items={GENDERS}
            register={form.register("individualGender")}
            placeholder="Select a gender"
          />
          <div className="col-span-2">
            <SimpleSelectFormField
              label="Primary language"
              register={form.register("individualPrimaryLanguage")}
              items={LANGUAGES}
              placeholder="Select a primary language"
              dataTestId="contact-individual-primary-language"
            />
          </div>
          <div className="col-span-2">
            <MultiselectFormField
              placeholder="Select secondary language(s)"
              label="Secondary language(s)"
              register={form.register("individualSecondaryLanguage")}
              options={LANGUAGES.map((language) => ({
                label: language,
                value: language,
              }))}
              dataTestId="contact-individual-secondary-language"
            />
          </div>
          <div className="col-span-2">
            <MultiselectFormField
              placeholder="Select race"
              label="Races"
              register={form.register("individualRace")}
              options={RACES.map((race) => ({
                label: race,
                value: race,
              }))}
              maxCount={1}
            />
          </div>
          <div className="col-span-2 grid grid-cols-subgrid gap-4">
            <CheckboxFormField
              label="Deceased?"
              register={form.register("individualDeceased")}
            />
          </div>
          <div className="grid grid-cols-subgrid gap-4">
            <CheckboxFormField
              label="Minor?"
              register={form.register("individualMinor")}
            />
          </div>
        </>
      )}
      {form.watch("individualSubTypes")?.includes("Expert Witness") && (
        <div className="col-span-2">
          <MultiselectFormField
            options={CONTACT_INDIVIDUAL_EXPERT_WITNESS_SPECIALIZATIONS.map(
              (specialization) => ({
                label: specialization,
                value: specialization,
              }),
            )}
            placeholder="Select expert witness specializations"
            label="Expert witness specializations"
            register={form.register("individualExpertWitnessSpecialization")}
            maxCount={1}
          />
        </div>
      )}
    </>
  );
};
